module.exports = __webpack_public_path__ + "static/alex_alexiev-9f385f601055c05ba6c2e38edd302dde.jpg";